import React from "react";
import {
	decodeStyle,
	isHidden,
	mobile,
	parseStyle,
	tablet,
} from "../../../../juntion";
// import { getTableContent } from "../../../../../dynamicdata/parser";
import { decodeAttribute, getContent, getTableContent } from "../../../../junctionAbs";
import QurealTableNew from "./QurealTableNew";
import { QurealTableNewView } from "../../../../juntion"

function QTable({ id, db, device, gs, dydb, ctx }) {
	const data = db[id];


	const ps = parseStyle(data, gs, data.cstate);

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	const tableData = getTableContent(dydb, input.tableData);


	const table_style = decodeStyle(ps.styleGroup?.table, gs);
	const cell_padding = decodeAttribute(ps.input.cellPadding, gs) || "8px";


	return (
		<div style={{
			width: "100%",
			height: "auto",
			// position: "relative"
		}}>
			<QurealTableNewView
				value={{
					rows: tableData?.rows || [],
					columns: input.tableData.columns || [],
					widths: input.tableData.widths || [30, 20, 50],
					cellStyles: input.tableData.cellStyles || {},
					selectedCell: input.tableData.selectedCell
				}}
				getContent={val => getContent(dydb, val)}
				table_style={table_style}
				cell_padding={cell_padding}
				border_width={input.borderWidth}
				border_color={typeof input.borderColor === "string" ? input.borderColor : decodeAttribute(input.borderColor, gs)}
				showHeader={input.showHeader}
				input={input}
			/>
		</div>

	);
}

export default QTable;

// https://developers.google.com/maps/documentation/embed/embedding-map
